import { Observable } from './observable.js';

/**
 * This is a temporary helper function to create an Observable from an EventTarget as an alternative to a global polyfill.
 *
 * When the draft proposal for EventTargetObservable is implemented, this function can be removed.
 * This will be available as target.when('event') in the future.
 *
 * @param target the EventTarget to listen for events on
 * @param type a string representing the event type to listen for on the given target
 * @returns an Observable that emits events of the given type
 */
export const when = (target: EventTarget, type: string) => new Observable(subscriber => {
    target.addEventListener(type, event => subscriber.next(event), { signal: subscriber.signal });
});

/** @deprecated renamed to `when` to align with WICG observable proposal */
export const on = when;
